import React from "react";
import PropTypes from "prop-types";
import SelectInput from "../../../common/forms/SelectInput";

const UtilizationRequestStatusFilter = React.forwardRef((props, ref) => {
  return (
    <SelectInput default="All" label="Status" onChange={props.onChange} options={props.statuses.sort()} ref={ref} />
  );
});

UtilizationRequestStatusFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  statuses: PropTypes.array.isRequired,
};

export default UtilizationRequestStatusFilter;
